<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>订单备货</span>
        <div>
          <el-button type="primary" size="small" @click="_goBack">
            <i class="el-icon-close"></i> 返回
          </el-button>
        </div>
      </div>
      <div class="text item">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">订单编码：</label>
              <label>{{ stockUpStoreOrderInfo.orderId }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">总金额:</label>
              <label>{{ stockUpStoreOrderInfo.payPrice }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">下单时间:</label>
              <label>{{ stockUpStoreOrderInfo.createTime }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">用户:</label>
              <label>{{ stockUpStoreOrderInfo.personName }}</label>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">是否分账:</label>
              <label>{{ stockUpStoreOrderInfo.profitSharing == 'N' ? '否' : '是' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">平台:</label>
              <label>{{ stockUpStoreOrderInfo.appName }}</label>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
      </div>
      <div class="text item">
        <el-table :data="stockUpStoreOrderInfo.storeOrderCarts" border style="width: 100%">
          <el-table-column type="selection" width="55" @selection-change="handleSelectionChange"
            :selectable="() => true">
          </el-table-column>
          <el-table-column label="商品图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px; border-radius: 10px;" :src="scope.row.coverPhoto"
                :preview-src-list="[scope.row.coverPhoto]" fit="cover">
                <div slot="error" class="image-slot">
                  <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px; border-radius: 10px;">
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="prodName" label="商品名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.prodName }}({{ scope.row.specValue }})
            </template>
          </el-table-column>
          <el-table-column prop="productId" label="商品编号" align="center"></el-table-column>
          <el-table-column prop="cartNum" label="数量" align="center">
            <template slot-scope="scope">
              {{ scope.row.cartNum }}
              <el-button type="text" icon="el-icon-minus" @click="_minusCartNum(scope.row)"
                v-if="scope.row.cartNum > 1"></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
          <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
          <el-table-column prop="createTime" label="支付时间" align="center"></el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>说明</span>
      </div>
      <div class="text item">
        <el-form label-width="120px">
          <el-form-item label="核销单号">
            <el-input v-model="stockUpStoreOrderInfo.extOrderId" placeholder="必填，请填写核销单号"
              style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item label="备货说明">
            <el-input type="textarea" v-model="stockUpStoreOrderInfo.stockUpRemark" placeholder="备货说明"
              style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_finishStockUpOrder" style="float: right;">备货完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryStoreOrder, queryStoreOrderCart, listStoreOrderWriteoff, stockUpStoreOrder } from '@/api/order/stockUpStoreOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'StockUpStoreOrder',
  data() {
    return {
      stockUpStoreOrderInfo: {
        orderId: '',
        appId: '',
        appName: '',
        deduction: '',
        personName: '',
        stateName: '',
        profitSharing: '',
        payPrice: '',
        createTime: '',
        quan: false,
        addressInfo: {
          username: '',
          tel: '',
          address: ''
        },
        remark: '',
        storeOrderCarts: [],
        selectCarts: [],
        extOrderId: '',
        stockUpRemark: '备货完成'
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this.stockUpStoreOrderInfo.orderId = this.$route.query.orderId
    this._loadStoreOrder()
    this._listOrderCart()
    this._listOrderWriteOff()
  },
  methods: {
    handleSelectionChange(val) {
      console.log('选中的商品:', val)
      console.log('商品列表:', this.stockUpStoreOrderInfo.storeOrderCarts)
      // 直接保存选中的完整对象，而不是只保存ID
      this.stockUpStoreOrderInfo.selectCarts = val
    },
    _loadStoreOrder() {
      const param = {
        page: 1,
        row: 1,
        orderId: this.stockUpStoreOrderInfo.orderId
      }
      queryStoreOrder(param).then(res => {
        Object.assign(this.stockUpStoreOrderInfo, res.data[0])
      }).catch(err => {
        console.log('请求失败处理', err)
      })
    },
    _listOrderCart() {
      const param = {
        page: 1,
        row: 1,
        orderId: this.stockUpStoreOrderInfo.orderId,
        shopId: this.shopId
      }
      queryStoreOrderCart(param).then(res => {
        const storeOrderCart = res.data
        storeOrderCart.forEach(orderCart => {
          if (orderCart.productSpecDetails) {
            let specValue = ''
            orderCart.productSpecDetails.forEach(detail => {
              specValue += (detail.detailValue + "/")
            })
            orderCart.specValue = specValue
          }
        })
        this.stockUpStoreOrderInfo.storeOrderCarts = storeOrderCart
      }).catch(err => {
        console.log('请求失败处理', err)
      })
    },
    _listOrderWriteOff() {
      const param = {
        page: 1,
        row: 1,
        orderId: this.stockUpStoreOrderInfo.orderId,
        shopId: this.shopId
      }
      listStoreOrderWriteoff(param).then(res => {
        this.stockUpStoreOrderInfo.extOrderId = res.data[0].woNum
      }).catch(err => {
        console.log('请求失败处理', err)
      })
    },
    _goBack() {
      this.$router.go(-1)
    },
    _minusCartNum(cart) {
      cart.cartNum -= 1
      if (cart.cartNum < 1) {
        cart.cartNum = 1
      }
    },
    _finishStockUpOrder() {
      if (!this.stockUpStoreOrderInfo.selectCarts || this.stockUpStoreOrderInfo.selectCarts.length < 1) {
        this.$message.warning("请选择商品")
        return
      }

      // 直接使用选中的商品对象
      const carts = this.stockUpStoreOrderInfo.selectCarts

      if (carts.length < 1) {
        this.$message.warning("请选择商品")
        return
      }

      const data = {
        shopId: this.shopId,
        orderId: this.stockUpStoreOrderInfo.orderId,
        carts: carts,
        extOrderId: this.stockUpStoreOrderInfo.extOrderId,
        stockUpRemark: this.stockUpStoreOrderInfo.stockUpRemark,
      }

      stockUpStoreOrder(data).then(res => {
        if (res.code === 0) {
          this.$router.go(-1)
          this.$message.success("添加成功")
          return
        }
        this.$message.error(res.msg)
      }).catch(err => {
        console.log('请求失败处理', err)
        this.$message.error(err)
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.col-form-label {
  font-weight: bold;
  margin-right: 10px;
}
</style>